import { Box } from '@mui/material';

import { Toolbar } from './Toolbar';

interface GeoMapWidgetPreviewProps {
  /** Whether this is the central widget (with hubs) or aside widget (without hubs) */
  isCentralWidget: boolean;
  /** Whether to show the custom GeoMap toolbar (only for central widget) */
  showToolbar?: boolean;
}

/**
 * Preview component for GeoMap widget in settings mode.
 * Renders a static image instead of the full map component for performance.
 * Central widget shows the image with hubs and includes the GeoMap toolbar.
 * Aside widget (Focus View) shows the image without hubs and uses standard widget toolbar.
 */
export const GeoMapWidgetPreview = ({
  isCentralWidget,
  showToolbar = false,
}: GeoMapWidgetPreviewProps) => {
  const imageSrc = isCentralWidget
    ? '/geo-map-with-hubs.svg'
    : '/geo-map-without-hubs.svg';
  const altText = isCentralWidget ? 'Geo Map' : 'Focus View';

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
      }}
    >
      <img
        src={imageSrc}
        alt={altText}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          objectPosition: 'center',
        }}
      />
      {/* Render GeoMap Toolbar in settings mode for central widget in preview */}
      {isCentralWidget && showToolbar && <Toolbar settingsMode />}
    </Box>
  );
};
